<template>
  <div>
    <basic-button :loading="saving" class="grey--text text--darken-2" depressed color="grey lighten-3" small @click="dismissOnboarding">
      <v-icon left>mdi mdi-close</v-icon>
      {{ $t('onboarding.dismiss_onboarding') }}
    </basic-button>
  </div>
</template>

<script>
import BasicButton from '@/components/BasicButton';
import tenantApi, { TenantValue } from '@/api/tenant';
import userApi from '@/api/user';
import UserService from '@/service/user.service';
export default {
  name: 'DismissOnboardingButton',
  components: { BasicButton },
  data() {
    return {
      saving: false,
    };
  },
  methods: {
    async dismissOnboarding() {
      this.saving = true;
      try {
        await tenantApi.createOrUpdateTenantValue(new TenantValue('onboarding', -1, this.$tenant));
        const me = await userApi.getMe();
        UserService.setUserInfo(me);
        this.$router.replace({ name: 'tenant_start' });
      } catch (e) {
        this.$handleApiError(e);
      }
      this.saving = false;
    },
  },
};
</script>

<style scoped></style>
